import { ButtonGroup, styled, Menu } from '@mui/material';

const MenuStyled = styled(Menu)(() => ({
  top: '9px'
}));

const prefix = 'HusaHeaderUser';
const buttonGroupClasses = {
  root: `${prefix}-root`,
  logo: `${prefix}-logo`
};
const ButtonGroupStyled = styled(ButtonGroup)(({ theme }) => {
  return {
    [`&.${buttonGroupClasses.root}`]: {
      borderStyle: 'none',
      '& > .MuiButtonBase-root': {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        border: 'none',
        background: theme.palette.background.default,
        color: theme.palette.primary.dark,
        textTransform: 'none',
        fontWeight: 'normal',
        '&:hover': {
          background: theme.palette.background.default,
          color: 'initial'
        }
      }
    },
    [`& .${buttonGroupClasses.logo}`]: {
      maxHeight: 38,
      marginLeft: theme.spacing(1)
    }
  };
});

const MarketMenuPrefix = 'MarketMenu';
const marketMenuClasses = {
  root: `${MarketMenuPrefix}-root`,
  company: `${MarketMenuPrefix}-company`,
  companyLogo: `${MarketMenuPrefix}-company-logo`,
  companyLogoContent: `${MarketMenuPrefix}-company-logo--content`
};
const MarketMenu = styled('li')(({ theme }) => {
  return {
    [`&.${marketMenuClasses.root}`]: {
      fontWeight: 'bold',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingTop: theme.spacing(1)
    },
    [`& .${marketMenuClasses.company}`]: {
      paddingLeft: theme.spacing(1)
    },
    [`& .${marketMenuClasses.companyLogo}`]: {
      width: 80,
      [`& .${marketMenuClasses.companyLogoContent}`]: {
        overflow: 'hidden',
        width: '100%',
        height: 40,
        paddingRight: theme.spacing(1),
        ['& img']: {
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        }
      }
    }
  };
});

export { ButtonGroupStyled, buttonGroupClasses, MarketMenu, marketMenuClasses, MenuStyled };
